export const toBath = (amount: number): string => {
  return `฿${(amount * 0.01).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};
